import { render, staticRenderFns } from "./editmessagesendgroup.vue?vue&type=template&id=fc45f68a&"
import script from "./editmessagesendgroup.vue?vue&type=script&lang=ts&"
export * from "./editmessagesendgroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editmessagesendgroup.vue"
export default component.exports